// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".direction-and-shoot-controller-area[data-v-1d218260]{position:absolute;bottom:9%;right:5px}.outer[data-v-1d218260]{width:inherit;height:inherit}.ptz-camera-view[data-v-1d218260]{width:100%;height:100%;background-color:#000}.rect-select-controller[data-v-1d218260]{position:absolute;top:55%;margin:20px}.zoom-controller-area[data-v-1d218260]{position:absolute;bottom:50%;right:80px}", ""]);
// Exports
module.exports = exports;
